/**
 * Исключение меток из `editor.getText()`.
 *
 * Передаётся явно в местах подсчёта, а НЕ объявляется как `renderText` у узла.
 * `renderText` пишется в `schema.toText`, откуда его подхватывает и сериализатор
 * клипборда: копирование абзаца с меткой в почту или мессенджер молча теряло бы
 * «[TK: …]». Метка не должна теряться нигде — поэтому исключение точечное.
 */
export const TK_TEXT_SERIALIZERS: Record<string, () => string> = {
  tkMarker: () => '',
};
